// import React from 'react';
// import { Link } from 'react-router-dom';
// import './maintenance.css';
// import foot from '../../main_assets/maintenancelogo.png';
// import foot2 from '../../main_assets/maintenancelogo1.png';

// const Maintenance = () => {
//     return (
//         <div className="landing-container maintenane-page">
//           <div className="ulev__footer">
//             <div className="ulev__footer-maintenance">
//               <div className='img'>
//                 <img src={foot} alt="logo" className="ulev__footer-btn-image" />
//               </div>
//               <div className='img'>
//                 <img src={foot2} alt="logo" className="ulev__footer-btn-image" />
//               </div>
//             </div>
            
//           </div>
//           <div className="landing-content">
//             <div className="landing-header">
//               <h1>Thank you for checking out the DESIGN CONA Magazine website!</h1>
//               <p>We're excited to bring you the latest<br />
//                 and greatest designs from all design disciplines across Africa.</p>
//             </div>
            
//             <hr className="divider" />
            
//             <div className="landing-forms">
//               <div className="form-container">
//                 <div className="form-row">
//                   <div className="form-text">
//                     <p>In the meantime, sign up for<br />
//                       our newsletter to<br />
//                       be notified when the<br />
//                       magazine launches!</p>
//                   </div>
//                   <div className="form-input">
//                     <input type="email" placeholder="Enter your email..." />
//                     <Link to="http://eepurl.com/jcNSOI" className="action-button">Sign up</Link>
//                   </div>
//                 </div>
//               </div>
              
//               <div className="form-container">
//                 <div className="form-text">
//                   <p>Interested in interning with us?<br />
//                     We're glad to have you on our team</p>
//                 </div>
//                 <div className="form-action">
//                   <Link to="https://bit.ly/designconaintern" className="action-button">Apply here</Link>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     };

// export default Maintenance;





import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './maintenance.css';
import foot from '../../main_assets/maintenancelogo.png';
import foot2 from '../../main_assets/maintenancelogo1.png';

const Maintenance = () => {
  const [showNewsletterForm, setShowNewsletterForm] = useState(false);

  const toggleNewsletterForm = () => {
    setShowNewsletterForm(!showNewsletterForm);
  };

  return (
    <div className="landing-container maintenane-page">
      {/* Newsletter Popup Modal */}
      {showNewsletterForm && (
        <div className="newsletter-modal-overlay">
          <div className="newsletter-modal">
            <button className="close-button" onClick={toggleNewsletterForm}>
              &times;
            </button>
            <iframe 
              src="https://designcona.us14.list-manage.com/subscribe?u=8e62fdedda28c013c29719fd5&id=4543b3a251" 
              width="100%" 
              height="700" 
              frameBorder="0" 
              scrolling="no"
              marginHeight="0" 
              marginWidth="0"
              title="Newsletter Signup"
            ></iframe>
          </div>
        </div>
      )}

      <div className="ulev__footer">
        <div className="ulev__footer-maintenance">
          <div className='img'>
            <img src={foot} alt="logo" className="ulev__footer-btn-image" />
          </div>
          <div className='img'>
            <img src={foot2} alt="logo" className="ulev__footer-btn-image" />
          </div>
        </div>
      </div>
      <div className="landing-content">
        <div className="landing-header">
          <h1>Thank you for checking out the DESIGN CONA Magazine website!</h1>
          <p>We're excited to bring you the latest<br />
            and greatest designs from all design disciplines across Africa.</p>
        </div>
        
        <hr className="divider" />
        
        <div className="landing-forms">
          <div className="form-container">
            <div className="form-row">
              <div className="form-text">
                <p>In the meantime, sign up for<br />
                  our newsletter to<br />
                  be notified when the<br />
                  magazine launches!</p>
              </div>
              <div className="form-input">
                <input type="email" placeholder="Enter your email..." />
                <button onClick={toggleNewsletterForm} className="action-button">Sign up</button>
              </div>
            </div>
          </div>
          
          <div className="form-container">
            <div className="form-text">
              <p>Interested in interning with us?<br />
                We're glad to have you on our team</p>
            </div>
            <div className="form-action">
              <Link to="https://bit.ly/designconaintern" className="action-button">Apply here</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;